

import { Injectable } from '@angular/core';
import sha from 'sha.js';
import * as CryptoJS from 'crypto-js';
@Injectable()
export class ScrambleUnscramblestring {
  readonly e1 = "E";
  readonly h2 = "h";
  readonly o2 = "o";
  readonly b1 = "W";
  readonly F = "F";
  readonly j = "j";
  readonly k2 = "l";
  readonly c1 = "o";
  readonly pq = "b";
  public hs= "";
  public hbs = "";
  public Scramble = "";
  public Unscramble = "";

constructor (){
}
 ApplyInternalFilter(a, b) {
  let ad33 = this.sdfs1231();
  this.hs = sha('sha256').update(ad33).digest('hex');
  this.hbs = this.hs.substring(0, 32);
  let Lock = CryptoJS.enc.Utf8.parse(this.hbs);

  let sym = CryptoJS.enc.Hex.parse('676c6f62616c616573766563746f7273');

  if (a == "Cloak") {
    var Scramble = CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(b), Lock, {
      keySize: 128 / 8,
      iv: sym,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    });
    var output = Scramble.ciphertext.toString(CryptoJS.enc.Base64);
    return output.split('+').join('-').split('/').join('_');

  } else if (a == "Unveil") {
    if (b != null) {
      var UnlockInput = b.split('-').join('+').split('_').join('/');
      var Unscramble = CryptoJS.AES.decrypt(UnlockInput, Lock, {
        keySize: 128 / 8,
        iv: sym,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
      });
      return Unscramble.toString(CryptoJS.enc.Utf8);
    }
    return null;
  }
}

ClearInternalFilter(a, b) {
  let p09sdf = this.ewrwon242();
  this.hs = sha('sha256').update(p09sdf).digest('hex');
  this.hbs = this.hs.substring(0, 32);
  let Lock = CryptoJS.enc.Utf8.parse(this.hbs);

  let sym = CryptoJS.enc.Hex.parse('676c6f62616c616573766563746f7273');

  if (a == "Unveil") {
    if (b != null) {
      var UnlockInput = b.split('-').join('+').split('_').join('/');
      var Unscramble = CryptoJS.AES.decrypt(UnlockInput, Lock, {
        keySize: 128 / 8,
        iv: sym,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
      });
      return Unscramble.toString(CryptoJS.enc.Utf8);
    }
    return null;
  } else if (a == "Cloak") {
    if (b != null) {
      var Scramble = CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(b), Lock, {
        keySize: 128 / 8,
        iv: sym,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
      });
      var output = Scramble.ciphertext.toString(CryptoJS.enc.Base64);
      return output.split('+').join('-').split('/').join('_');
    }
  }
}
   dsfgd(s) {
    let e1 = s;
    return e1 + this.vjs('VJ');
}
vjs(d) {
    let rando = Math.random() * 2;
    return d;
}
getvalue() {
    let m = "T"
    return m
}
getappend() {
    return "E"+ this.h('h') + this.o2 + this.pq
};

h(sf) {
    return sf;
}

dfsdf() {
    let b1 = this.b1;
    let F = this.a23s(this.F)
    let j = this.j;
    return this.fdgfg(b1 + F + j)
}

a23s(dsd) {
    return dsd;
}
fdgfg(df) {

    return df;
}

Getsolve(){
return this.h('E') + this.k2 + this.c1;
}
addcalcu(){
let g7 = this.pq;
let kk = this.oup(this.b1)
let F = this.a23s(this.F)
let j = this.j;
return this.kuytrg(g7 + kk + F + j)

}
kuytrg(gh){
return gh;
}
dsfghegd(s) {
let e1 = s;
return e1 + this.vjs('RY');
}
oup(dsd) {
return dsd;
}
jfjgftr(){
let m = "T"
return m
}
  sdfs1231(){
   let a2="T";
    let B2="k";
   return a2+  this.dsfgd(B2)+this.getvalue()+this.getappend()+this.dfsdf();
  }
ewrwon242(){
let v6 = "U";
let H9 = "k";

 return v6 + this.dsfghegd(H9)+ this.jfjgftr() + this.Getsolve() + this.addcalcu();
}
}